import React, { useState } from 'react';
import './styles/ReviewVideos.css';
import tumbnail1 from './assets/videos/01.png';
import video1 from './assets/videos/01.mp4';
import tumbnail2 from './assets/videos/02.png';
import video2 from './assets/videos/02.mp4';
import tumbnail3 from './assets/videos/03.png';
import video3 from './assets/videos/03.mp4';
import tumbnail4 from './assets/videos/04.png';
import video4 from './assets/videos/04.mp4';
import tumbnail5 from './assets/videos/05.png';
import video5 from './assets/videos/05.mp4';
import tumbnail6 from './assets/videos/06.png';
import video6 from './assets/videos/06.mp4';
import tumbnail7 from './assets/videos/07.png';
import video7 from './assets/videos/07.mp4';
import tumbnail8 from './assets/videos/08.png';
import video8 from './assets/videos/08.mp4';
import tumbnail9 from './assets/videos/09.png';
import video9 from './assets/videos/09.mp4';
import tumbnail10 from './assets/videos/10.png';
import video10 from './assets/videos/10.mp4';

const videoData = [
    { id: 1, title: "Video 1", description: "Description for Video 1", src: video1, thumbnail: tumbnail1 },
    { id: 2, title: "Video 2", description: "Description for Video 2", src: video2, thumbnail: tumbnail2 },
    { id: 3, title: "Video 3", description: "Description for Video 3", src: video3, thumbnail: tumbnail3 },
    { id: 4, title: "Video 4", description: "Description for Video 4", src: video4, thumbnail: tumbnail4 },
    { id: 5, title: "Video 5", description: "Description for Video 5", src: video5, thumbnail: tumbnail5 },
    { id: 6, title: "Video 6", description: "Description for Video 6", src: video6, thumbnail: tumbnail6 },
    { id: 7, title: "Video 7", description: "Description for Video 7", src: video7, thumbnail: tumbnail7 },
    { id: 8, title: "Video 8", description: "Description for Video 8", src: video8, thumbnail: tumbnail8 },
    { id: 9, title: "Video 9", description: "Description for Video 9", src: video9, thumbnail: tumbnail9 },
    { id: 10, title: "Video 10", description: "Description for Video 10", src: video10, thumbnail: tumbnail10 },
];

const VideoGallery = () => {
    const [selectedVideoId, setSelectedVideoId] = useState(null);

    const handleVideoClick = (videoId) => {
        setSelectedVideoId(selectedVideoId === videoId ? null : videoId);
    };

    return (
        <div className="video-gallery">
            <div className="video-grid">
                {videoData.map((video) => (
                    <div className="video-thumbnail" key={video.id} onClick={() => handleVideoClick(video.id)}>
                        {selectedVideoId === video.id ? (
                            <video width="100%" controls>
                                <source src={video.src} type="video/mp4" />
                            </video>
                        ) : (
                            <>
                                <img src={video.thumbnail} alt={video.title} />
                                <button className="play-button">▶</button>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VideoGallery;
